/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { kahuCopyInfoType, kahuLinkType } from 'types/kahu';

export const handleCopyLink = async (
  e: React.MouseEvent<HTMLButtonElement>,
  text: string,
  href: string,
  occurrenceKey: string,
  copiedContentType: kahuLinkType,
  setCopiedInfo: React.Dispatch<React.SetStateAction<kahuCopyInfoType | null>>
) => {
  e.preventDefault();
  e.stopPropagation();

  await navigator.clipboard.writeText(text);
  setCopiedInfo({
    text,
    href,
    id: Date.now(),
    copiedContentType,
    occurrenceKey,
  });
};
